"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as t } from "../../../utils/styles.mjs";
import { Text as n } from "../Text/Text.mjs";
import { createContext as r, isValidElement as i, useContext as a } from "react";
import { jsx as o } from "react/jsx-runtime";
import { cva as s } from "class-variance-authority";
import * as c from "@radix-ui/react-tabs";
//#region src/components/atoms/Tabs/Tabs.tsx
var l = r({}), u = s(`data-[state=active]:bg-gray-800 data-[state=active]:text-white data-[state=active]:font-semibold
    inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-3 border border-transparent px-4 py-3 border-none whitespace-nowrap
    ${t()}
    disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer
    [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`, {
	variants: {
		shape: {
			square: "rounded-sm data-[state=active]:rounded-sm",
			rounded: "rounded-md data-[state=active]:rounded-capsule"
		},
		outline: {
			true: "data-[state=active]:border data-[state=active]:border-solid data-[state=active]:border-gray-500",
			false: ""
		}
	},
	defaultVariants: {
		shape: "rounded",
		outline: !1
	}
}), d = ({ className: t, shape: n, outline: r, ...i }) => /* @__PURE__ */ o(l.Provider, {
	value: {
		shape: n,
		outline: r
	},
	children: /* @__PURE__ */ o(c.Root, {
		"data-slot": "tabs",
		className: e("flex flex-col gap-2", t),
		...i
	})
}), f = ({ className: t, ...n }) => /* @__PURE__ */ o(c.List, {
	"data-slot": "tabs-list",
	className: e("inline-flex h-13 w-fit items-center justify-center", t),
	...n
}), p = ({ className: t, asChild: r, children: s, fontSize: d = "base", fontWeight: f = "regular", fontFamily: p = "inter", ...m }) => {
	let { shape: h, outline: g } = a(l);
	return /* @__PURE__ */ o(c.Trigger, {
		asChild: r,
		"data-slot": "tabs-trigger",
		className: e(u({
			shape: h,
			outline: g
		}), t),
		...m,
		children: /* @__PURE__ */ o(n, {
			asChild: !0,
			fontSize: d,
			fontWeight: f,
			fontFamily: p,
			children: i(s) ? s : /* @__PURE__ */ o("span", { children: s })
		})
	});
}, m = ({ className: t, ...n }) => /* @__PURE__ */ o(c.Content, {
	"data-slot": "tabs-content",
	className: e("flex-1 outline-none", t),
	...n
});
//#endregion
export { m as TabsContent, f as TabsList, d as TabsRoot, p as TabsTrigger };
